import React, { useEffect, useRef } from 'react';

export default function MotionPermissionPrompt({ pending, onEnable, onDismiss, stageRef }) {
  const dialogRef = useRef(null);
  const enableRef = useRef(null);
  const dismissRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    const stage = stageRef.current;
    if (dialog.showModal) dialog.showModal();
    else dialog.setAttribute('open', '');
    enableRef.current.focus({ preventScroll: true });
    return () => {
      if (dialog.open) dialog.close?.();
      if (stage?.isConnected) stage.focus({ preventScroll: true });
    };
  }, [stageRef]);

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      onDismiss();
    } else if (event.key === 'Tab') {
      // Native dialogs contain focus; also support the open-attribute fallback.
      const first = pending ? dismissRef.current : enableRef.current;
      const last = dismissRef.current;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  return (
    <div className="world-motion-prompt-backdrop" onClick={(event) => {
      if (event.target === event.currentTarget) onDismiss();
    }}>
      <dialog ref={dialogRef} className="world-motion-prompt" aria-modal="true"
        aria-labelledby="world-motion-prompt-title" aria-describedby="world-motion-prompt-description"
        onKeyDown={onKeyDown}
        onCancel={(event) => { event.preventDefault(); onDismiss(); }}
        onClick={(event) => {
          if (event.target !== event.currentTarget) return;
          const bounds = event.currentTarget.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right
            || event.clientY < bounds.top || event.clientY > bounds.bottom) onDismiss();
        }}>
        <h2 id="world-motion-prompt-title">Look around by moving your phone</h2>
        <p id="world-motion-prompt-description">Enable motion to turn your view as you move your phone. You can still tap buttons and swipe to scroll.</p>
        <button ref={enableRef} type="button" className="world-primary-button"
          disabled={pending} aria-busy={pending} onClick={onEnable}>Enable motion</button>
        <button ref={dismissRef} type="button" className="world-motion-skip" onClick={onDismiss}>Use touch only</button>
      </dialog>
    </div>
  );
}
